import { takeLatest, call, put } from 'redux-saga/effects';

import { checkIfAPIResponseIsSuccess } from 'utils/functions/general';
import { getCompanyProfiles } from 'modules/common/api';

import { updateCompanyLicenceStatus } from './api';
import {
  fetchCompanyActivationListSuccess,
  fetchCompanyActivationListFail,
  fetchUpdateCompanyLicenceStatusSuccess,
  fetchUpdateCompanyLicenceStatusFail,
} from './actions';
import companyActivationActionTypes from './action-types';

function* fetchCompanyActivationListSaga({ payload }) {
  try {
    const response = yield call(getCompanyProfiles, payload);

    if (checkIfAPIResponseIsSuccess(response.status) === false) throw new Error(response.status);

    yield put(fetchCompanyActivationListSuccess(response.data.data));
  } catch (error) {
    yield put(fetchCompanyActivationListFail(error));
  }
}

function* fetchUpdateCompanyLicenceStatusSaga({ payload }) {
  const { actionPopupCallbackAction } = payload;

  try {
    const response = yield call(updateCompanyLicenceStatus, payload);

    if (checkIfAPIResponseIsSuccess(response.status) === false) throw new Error(response.status);

    actionPopupCallbackAction(true);
    yield put(fetchUpdateCompanyLicenceStatusSuccess(response.data.data));
  } catch (error) {
    actionPopupCallbackAction();
    yield put(fetchUpdateCompanyLicenceStatusFail(error));
  }
}

function* companyActivationSaga() {
  yield takeLatest(
    companyActivationActionTypes.FETCH_COMPANY_ACTIVATION_LIST,
    fetchCompanyActivationListSaga,
  );
  yield takeLatest(
    companyActivationActionTypes.FETCH_UPDATE_COMPANY_LICENCE_STATUS,
    fetchUpdateCompanyLicenceStatusSaga,
  );
}

export default companyActivationSaga;
